import { Trans, useTranslation } from "react-i18next";
import { useAppSelector } from "../../app/hooks";
import { selectHotel } from "../../features/hotel/hotelSlice";

function CalendarTop() {
  const hotel = useAppSelector(selectHotel);
  const { t } = useTranslation();
  
  return (
    <>
      <div className="px-4 py-3 border-b border-black/10">
        <div className="grid grid-cols-7 w-full text-fluid-base text-center">
          <div>{t(`weekDays.1`)}</div>
          <div>{t(`weekDays.2`)}</div>
          <div>{t(`weekDays.3`)}</div>
          <div>{t(`weekDays.4`)}</div>
          <div>{t(`weekDays.5`)}</div>
          <div>{t(`weekDays.6`)}</div>
          <div>{t(`weekDays.0`)}</div>
        </div>
      </div>

      {import.meta.env?.[
        "VITE_MEWS_" + hotel.HotelCode + "_CALENDAR_START_TEXT"
      ] !== undefined && (
        <div className="px-4 py-2 ">
          {hotel.Name !== undefined && (
            <div className="rounded-md bg-green-600 text-white p-2">
              <p className="text-fluid-base">
                <Trans i18nKey="scenes.calendar.startNotice"
                  values={{ hotelName: hotel.Name[hotel.DefaultLanguageCode], startDate: import.meta.env?.[
                    "VITE_MEWS_" + hotel.HotelCode + "_CALENDAR_START_TEXT"
                  ] }}
                  components={{ strong: <strong /> }}
                />
              </p>
            </div>
          )}
        </div>
      )}
    </>
  );
}
export default CalendarTop;
